import api from './api';

/* 
   1) GET /hr-requests
 */
export async function fetchHrRequests(params) {
  const res = await api.get('/hr-requests', { params });
  return res.data;
}

/* 
   2) POST /hr-requests
 */
export const createHrRequest = async (formValues) => {
  const fd = new FormData();
  fd.append('request_type', formValues.request_type);

  /* optional common fields */
  ['request_date', 'priority', 'due_date', 'notes'].forEach((k) => {
    if (formValues[k]) fd.append(k, formValues[k]);
  });

  /* ---------- to_leave ---------- */
  if (formValues.request_type === 'to_leave') {
    fd.append('leave_type',   formValues.leaveType  || '');
    fd.append('from_date',    formValues.fromDate   || '');
    fd.append('from_time',    formValues.fromTime   || '');
    fd.append('to_date',      formValues.toDate     || '');
    fd.append('to_time',      formValues.toTime     || '');
    fd.append('description',  formValues.reason     || '');
  }

  /* ---------- loans ---------- */
  else if (formValues.request_type === 'loans') {
    fd.append('loan_date',      formValues.loanDate      || '');
    fd.append('no_of_payments', formValues.noOfPayments  || '');
    fd.append('amount',         formValues.loanAmount    || '');
    fd.append('description',    formValues.loanReason    || '');
  }

  /* ---------- personal-data change  (FIXED) ---------- */
  else if (formValues.request_type === 'personal_data_change') {
    fd.append('personal_data_field',  formValues.personalDataField  || '');
    fd.append('personal_data_value',  formValues.personalDataValue  || '');
    fd.append('description',          formValues.description        || '');
    // attachment is optional - handled later with the common section
  }

  /* ---------- finance_claim ---------- */
  else if (formValues.request_type === 'finance_claim') {
    const { financeClaims = [] } = formValues;
    financeClaims.forEach((item, i) => {
      fd.append(`financeClaims[${i}][transaction_date]`, item.transaction_date || '');
      fd.append(`financeClaims[${i}][expense_type]`,     item.expense_type     || '');
      fd.append(`financeClaims[${i}][amount]`,           item.amount           || '');
      fd.append(`financeClaims[${i}][notes]`,            item.notes            || '');
      if (item.attachment) {
        fd.append(`financeClaims[${i}][attachment]`, item.attachment);
      }
    });
  }

  /* ---------- misc ---------- */
  else if (formValues.request_type === 'misc') {
    fd.append('requested_item', formValues.requestedItem || '');
    fd.append('is_temporary',   formValues.isTemporary ? '1' : '0');
    if (formValues.isTemporary) {
      fd.append('miscFromDate', formValues.miscFromDate || '');
      fd.append('miscFromTime', formValues.miscFromTime || '');
      fd.append('miscToDate',   formValues.miscToDate   || '');
      fd.append('miscToTime',   formValues.miscToTime   || '');
    }
    fd.append('miscReason', formValues.miscReason || '');
    fd.append('miscNotes',  formValues.miscNotes  || '');
  }

  /* ---------- business_trip ---------- */
  else if (formValues.request_type === 'business_trip') {
    fd.append('business_trip_ticket_demand', formValues.business_trip_ticket_demand || '');
    fd.append('business_trip_type', formValues.business_trip_type || '');
    fd.append('business_trip_region', formValues.busTripRegion || '');
    fd.append('business_trip_travel_method', formValues.business_trip_travel_method || '');
    fd.append('business_trip_destination', formValues.business_trip_destination || '');
    fd.append('description',          formValues.busTripReason || '');
    fd.append('notes',                formValues.busTripNotes  || '');
    fd.append('from_date',            formValues.fromDate      || '');
    fd.append('to_date',              formValues.toDate        || '');
    fd.append('from_time',            formValues.fromTime      || '');
    fd.append('to_time',              formValues.toTime        || '');
    (formValues.businessTripAttachments || []).forEach((f, i) =>
      fd.append(`attachments[${i}]`, f),
    );
  }

  /* ---------- bank ---------- */
  else if (formValues.request_type === 'bank') {
    fd.append('bank_transaction_date', formValues.bankTransactionDate || '');
    fd.append('bank_name',             formValues.bankName           || '');
    fd.append('bank_branch',           formValues.bankBranch         || '');
    fd.append('new_account_number',    formValues.newAccountNumber   || '');
    fd.append('new_iban_number',       formValues.newIbanNumber      || '');
    fd.append('swift_code',            formValues.swiftCode          || '');
    fd.append('bank_notes',            formValues.bankNotes          || '');
  }

  /* ---------- resignation ---------- */
  else if (formValues.request_type === 'resignation') {
    fd.append('resignation_date',  formValues.resignation_date  || '');
    fd.append('last_working_day',  formValues.last_working_day  || '');
    fd.append('notice_period',     formValues.notice_period     || '');
    fd.append('resignation_reason',formValues.resignation_reason|| '');
  }

  /* ---------- missing_punch ---------- */
  else if (formValues.request_type === 'missing_punch') {
    fd.append('missing_punch_date', formValues.missing_punch_date || '');
    fd.append('missing_punch_type', formValues.missing_punch_type || '');
    fd.append('missing_punch_time', formValues.missing_punch_time || '');
    fd.append('missing_punch_project_id', formValues.missing_punch_project_id || '');
    fd.append('description', formValues.description || '');
  }

  /* ---------- pre_approval ---------- */
  else if (formValues.request_type === 'pre_approval') {
    fd.append('candidate_name', formValues.candidate_name ?? '');
    fd.append('position_offered', formValues.position_offered ?? '');
    fd.append('project_client', formValues.project_client ?? '');
    fd.append('pre_approval_department_id', formValues.pre_approval_department_id ?? '');
    fd.append('package_salary', formValues.package_salary ?? '');
    fd.append('other_cost', formValues.other_cost ?? '');
    fd.append('total_cost_to_company', formValues.total_cost_to_company ?? '');
    fd.append('conditional_terms', formValues.conditional_terms ?? '');
    fd.append('conflict_of_interest', formValues.conflict_of_interest ?? '');
    fd.append('requester_name', formValues.requester_name ?? '');
    fd.append('prepared_by_name', formValues.prepared_by_name ?? '');
  }

  /* optional single attachment */
  if (formValues.attachment) {
    fd.append('attachment', formValues.attachment);
  }

  const res = await api.post('/hr-requests', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

/* 
   3) GET /hr-requests/:id
 */
export const showHrRequest = async (id) => (await api.get(`/hr-requests/${id}`)).data;

/* 
   4) PUT /hr-requests/:id
 */
export async function updateRequestStatus(id, status, extra = '') {
  const payload = { status };
  const legacyFieldHints = new Set([
    'status',
    'hr_status',
    'finance_coordinator_status',
    'finance_status',
    'ceo_status',
    'pre_approval_hod_status',
    'pre_approval_operations_status',
    'pre_approval_ceo_status',
    'pre_approval_executive_md_status',
  ]);

  if (extra && typeof extra === 'object' && !Array.isArray(extra)) {
    Object.entries(extra).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      payload[key] = value;
    });
  } else if (typeof extra === 'string' && extra.trim() && !legacyFieldHints.has(extra)) {
    payload.rejection_reason = extra.trim();
  }

  return (await api.put(`/hr-requests/${id}/status`, payload)).data;
}

export async function downloadPreApprovalPdf(id, download = false) {
  const res = await api.get(`/hr-requests/${id}/pre-approval-pdf`, {
    params: { download: download ? 1 : 0 },
    responseType: 'blob',
  });
  return res.data;
}

export const updateHrRequest = async (id, formValues) => {
  const fd = new FormData();
  [
    'status',
    'description',
    'amount',
    'item_name',
    'personal_data_field',
    'personal_data_value',   // NEW
    'transaction_date',
    'loan_period',
    'request_date',
    'priority',
    'due_date',
    'notes',
    'from_date',
    'from_time',
    'to_date',
    'to_time',
    'business_trip_ticket_demand',
    'business_trip_type',
    'business_trip_region',
    'business_trip_travel_method',
    'business_trip_destination',
    'missing_punch_date',
    'missing_punch_type',
    'missing_punch_time',
    'missing_punch_project_id',
    'candidate_name',
    'position_offered',
    'project_client',
    'pre_approval_department_id',
    'package_salary',
    'other_cost',
    'total_cost_to_company',
    'pre_approval_billing_mode',
    'client_billing',
    'marginal_benefit',
    'conditional_terms',
    'conflict_of_interest',
    'requester_name',
    'prepared_by_name',
  ].forEach((k) => {
    if (formValues[k] !== undefined && formValues[k] !== null && formValues[k] !== '') {
      fd.append(k, formValues[k]);
    }
  });
  if (formValues.request_type === 'business_trip') {
    if (formValues.busTripRegion) fd.set('business_trip_region', formValues.busTripRegion);
    if (formValues.busTripReason) fd.set('description', formValues.busTripReason);
    if (formValues.busTripNotes) fd.set('notes', formValues.busTripNotes);
  }
  if (formValues.attachment) fd.append('attachment', formValues.attachment);
  fd.append('_method', 'PUT');

  return (
    await api.post(`/hr-requests/${id}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  ).data;
};

/* 
   5) DELETE /hr-requests/:id
 */
export const deleteHrRequest = async (id) =>
  (await api.delete(`/hr-requests/${id}`)).data;

export async function fetchHrAssignedBreakdown(queue = 'pending') {
  const res = await api.get('/hr-requests/assigned-breakdown', { params: { queue } });
  return res.data;
}

export async function exportAllRequestsExcel(params = {}) {
  const res = await api.get('/admin/reports/all-requests/export', {
    params,
    responseType: 'blob',
  });

  return res;
}

export async function fetchAdminRequestsReport(params = {}) {
  const res = await api.get('/admin/reports/requests', { params });
  return res.data;
}


